import { filterValidMults, getMaxMult, getMinMult, buildSP, getMaxSP, getMinSP, findValuationTileInTray, checkMult } from './sub-services/helpers.js';
import { filterManyByIds, findOneById }                                                                              from '../../utilities/idResolution';

export const resolve52WeekHighLow = (company) => {
  return {
    fiftyTwoWeekHigh: company.fiftyTwoWeekHigh,
    fiftyTwoWeekLow:  company.fiftyTwoWeekLow
  }
}

export const resolveChoosenMultField = (tiles, selectedTileIds, valuationOptions, defaultMultName, company) => {
  // Leveraging NEP Technique (Normalize, Enrich, Project) in Main Service Orchestration\

  // 1) Normalize: data to reflect only valuation tiles
  const valuationTileInTray = findValuationTileInTray(tiles, selectedTileIds, valuationOptions)

  // 2) Enrich: N/A here, not calcing any derivatives from the data set

  // 3) Project: send back upstream - project the shape / value - what you want the rest of the component to consume
  // if any of them are a valuation mult tile, check to make sure that stat is not N/A for the target co., and if it is, resolve to a ttm multiple which will always have a value
  const resolveToValidCompanyMult = checkMult(company, defaultMultName, valuationTileInTray)
  return resolveToValidCompanyMult
}

export const getSharePriceRange = (selectedComparablesData, selectedSectorIds, multFieldChoosen, selectedCoDataObj) => {
  // Step 1 NEP Orchestration: Normalize (data to reflect valid multiples in list of selected companies)
  const selection            = filterManyByIds(selectedComparablesData, selectedSectorIds)
  const cleanListOfMultiples = filterValidMults(selection, multFieldChoosen) 

  console.log("[MULT ARRAY]: ", cleanListOfMultiples.map(company => company[multFieldChoosen]).sort((a, b) => b - a).map(val => val.toFixed(1)))
  
  // STEP 2 NEP Orchestration: Enrich (calc derivative values)
  const multHigh  = getMaxMult(cleanListOfMultiples, multFieldChoosen);
  const multLow   = getMinMult(cleanListOfMultiples, multFieldChoosen);
  
  console.log("[CURRENT MULT]: ", selectedCoDataObj[multFieldChoosen].toFixed(1))
  console.log("[HIGH/LOW COMPS/TRANS MULTS]:", multHigh.toFixed(1), multLow.toFixed(1))
  
  const SPFromHighMult  = buildSP(multHigh, multFieldChoosen, selectedCoDataObj);
  const SPFromLowMult   = buildSP(multLow, multFieldChoosen, selectedCoDataObj);

  console.log("[COMPS High/Low Price From Mults]:", SPFromHighMult.toFixed(2), SPFromLowMult.toFixed(2))

  // STEP 3 NEP Orchestration: Project (the shape / value you want the downstream pieces of the component to consume)
  const SPHigh          = Math.max(SPFromHighMult, SPFromLowMult)
  const SPLow           = Math.min(SPFromHighMult, SPFromLowMult)
  
  console.log("[CURRENT PRICE]:", selectedCoDataObj.sharePrice)
  console.log("[COMPS High/Low Price]:", SPHigh.toFixed(2), SPLow.toFixed(2))
  console.log("[52 WK high/low price]:", selectedCoDataObj.fiftyTwoWeekHigh, selectedCoDataObj.fiftyTwoWeekLow)
  
  return { SPHigh, SPLow, multHigh, multLow };
}

export const resolveAxisMaxY = (bars) => {
  const maxSP = getMaxSP(bars)
  return Math.ceil(maxSP * 1.2);
}

export const resolveAxisMinY = (bars) => {
  const minSP = getMinSP(bars)
  return minSP >= 0 ? 0 : Math.floor(minSP * 1.25)

}
